const SAFE_INSIGHT_FAILURE_MESSAGE = "Insight generation failed. Please retry.";

export function classifyInsightResponse(response) {
  const statusCode = response?.status;
  const data = response?.data || {};
  const insight = String(data.insight || "");
  const insightStatus = String(data.insight_status || "").trim() || "not_requested";
  const statusText = String(data.status || "").trim();

  if (insight) {
    return {
      mode: "blocking_result",
      insight,
      insightStatus,
    };
  }

  if (statusText === "already_generated") {
    return {
      mode: "already_generated",
      baseResponseId: data.base_response_id || null,
      sessionId: data.session_id || null,
      sourceDbConfigId: data.source_db_config_id ?? null,
      messageId: data.message_id || null,
      insightStatus,
    };
  }

  if (
    statusCode === 202 ||
    insightStatus === "generating" ||
    statusText === "queued" ||
    statusText === "running"
  ) {
    return {
      mode: "job_submitted",
      baseResponseId: data.base_response_id || null,
      sessionId: data.session_id || null,
      sourceDbConfigId: data.source_db_config_id ?? null,
      insightStatus,
      status: statusText || "queued",
    };
  }

  return { mode: "blocking_result", insight: "", insightStatus };
}

export function mergeInsightStreamPayload(message, eventName, payload = {}) {
  if (eventName === "insight_queued" || eventName === "insight_started") {
    return {
      ...message,
      insightStatus: "generating",
      insightError: null,
      isInsightEligible: true,
      sourceDbId:
        payload.source_db_config_id ??
        payload.source_db_id ??
        message?.sourceDbId ??
        null,
    };
  }

  if (eventName === "insight_completed") {
    const insight = String(payload.insight || "");
    return {
      ...message,
      messageId: payload.message_id || message?.messageId || null,
      insight,
      insightStatus: payload.insight_status || "completed",
      insightError: null,
      isInsightEligible: true,
      sourceDbId:
        payload.source_db_config_id ??
        payload.source_db_id ??
        message?.sourceDbId ??
        null,
    };
  }

  if (eventName === "insight_failed") {
    return {
      ...message,
      messageId: payload.message_id || message?.messageId || null,
      insight: message?.insight || null,
      insightStatus: "failed",
      insightError: SAFE_INSIGHT_FAILURE_MESSAGE,
      isInsightEligible: true,
    };
  }

  return message;
}

export function getInsightJobErrorMessage(error) {
  const statusCode = error?.response?.status;
  const data = error?.response?.data || {};
  const status = String(data.status || "").trim();

  if (statusCode === 409 || status === "base_response_id_conflict") {
    return "This insight request conflicts with another result. Please rerun the query and try again.";
  }

  if (statusCode === 503 || status === "enqueue_failed") {
    return "The insight queue is temporarily unavailable. Please retry in a moment.";
  }

  if (status === "generation_failed" || data.insight_status === "failed") {
    return SAFE_INSIGHT_FAILURE_MESSAGE;
  }

  return (
    data.error ||
    data.message ||
    error?.message ||
    "Unable to generate insights. Please try again."
  );
}
